// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3A1B-","filesListContainer":"PosDisputesFiles_filesListContainer__1Et2J","filesButton":"PosDisputesFiles_filesButton__3My8f"};